var App = App || {};

App.Registration = (function ($, Vue) {
	"use strict";

	function init(siteKey) {
		new Vue({
			el: "#registration-app",
			data: {
				form: {
					firstName: '',
					middleInitial: '',
					lastName: '',
					street: '',
					city: '',
					postalCode: '',
					email: '',
					phone: '',
					phoneExt: '',
					securityQuestion: '',
					securityAnswer: '',
					prostaffPrograms: '',
					opticsUser: '',
					agreedToTerms: false,
					recaptchaToken: '',
					hobbies: [],
					timeInRetail: '',
					country: "USA",
					region: "",
					dealer: null,
					useCustomDealer: false,
					customDealer: {
						name: "",
						address: ""
					}
				},
				countries: [],
				dealers: [],
				siteKey: siteKey,
				isSubmitting: false,
				alertMessage: "",
				alertErrors: [],
				emailError: "",
				isComplete: false
			},
			computed: {
				currentCountry: function () {
					return this.countries.find(c => c.code === this.form.country);
				},
				currentRegions: function () {
					return this.currentCountry?.regions || [];
				},
				storeAddress: function () {
					return [this.form.dealer?.street, this.form.dealer?.city, this.form.dealer?.region]
						.filter(Boolean)
						.join(", ");
				}
			},
			methods: {
				onCountryChange: function () {
					const selectedCountry = this.countries.find(c => c.code === this.form.country);
					this.form.region = (selectedCountry?.regions?.[0]?.code) || "";
				},
				formatDealerLabel: function (dealer) {
					if (!dealer)
						return "";

					return `${dealer.name} (${dealer.city}, ${dealer.state})`;
				},
				loadCountries: function () {
					$.ajax({
						url: "/api/countries",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response.success) {
							this.countries = response.data;
							this.onCountryChange();
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading countries:", status, err);
					});
				},
				loadDealers: function () {
					$.ajax({
						url: "/api/dealers/all",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response.success) {
							this.dealers = response.data;
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading dealers:", status, err);
					});
				},
				setRecaptchaToken(token) {
					this.form.recaptchaToken = token;
				},
				submitForm: function (e) {
					const form = e.target.closest("form");
					if (!form.checkValidity()) {
						form.classList.add("was-validated");
						return;
					}

					grecaptcha.ready(() => {
						grecaptcha.execute(this.siteKey, { action: 'submit' })
							.then(token => {
								this.form.recaptchaToken = token;
								this.sendForm();
							})
							.catch(err => {
								console.error("reCAPTCHA failed:", err);
								alert("reCAPTCHA validation failed. Please try again.");
							});
					});
				},
				sendForm() {
					if (this.isSubmitting)
						return;

					this.isSubmitting = true;

					this.alertMessage = "";
					this.alertErrors = [];
					this.emailError = "";
					this.$el.querySelector('#email').setCustomValidity("");

					$.ajax({
						url: '/api/registration/submit',
						method: 'POST',
						contentType: 'application/json',
						data: JSON.stringify(this.form)
					})
						.done(response => {
							if (response?.success) {
								this.isComplete = true;
								this.$refs.successAlert?.focus?.({ preventScroll: true });
							} else {
								this.alertMessage = response?.message || 'Registration failed.';
								this.alertErrors = (response?.data?.errors || [])
									.map(e => e?.description)
									.filter(Boolean);

								const dupEmail = (response?.data?.errors || []).find(e => e?.code === 'DuplicateEmail');
								if (dupEmail) {
									this.emailError = dupEmail.description || 'Email is already in use.';
									this.$el.querySelector('#email').setCustomValidity(this.emailError);
								}

								this.$el.querySelector('form').classList.add('was-validated');
							}
						})
						.fail((jqXHR, status, err) => {
							console.error("AJAX error:", status, err);
							this.alertMessage = "Unable to complete registration. Please try again.";
							this.$el.querySelector('form').classList.add('was-validated');
						})
						.always(() => {
							this.isSubmitting = false;
							this.scrollToFormTop();
						});
				},
				scrollToFormTop() {
					this.$nextTick(() => {
						const topOffset = this.$el.getBoundingClientRect().top + window.pageYOffset - 20;
						window.scrollTo({ top: topOffset, behavior: 'smooth' });
						this.$refs.topAlert?.focus?.({ preventScroll: true });
					});
				},
			},
			mounted: function () {
				this.loadCountries();
				this.loadDealers();
			},
			watch: {
				'form.email': function () {
					this.emailError = "";
					this.$el.querySelector('#email').setCustomValidity("");
					this.$el.classList.remove('was-validated');
				}
			}
		});
	}

	return {
		init: init
	};
})(jQuery, Vue);
